export enum CompanyType {
  Juridical = 'JURIDICAL',
  Individual = 'INDIVIDUAL',
}

/** Канал доставки кода подтверждения телефона */
export enum PhoneCodeChannel {
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP',
}
